import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash'
import { response } from 'express';
@Injectable({
  providedIn: 'root'
})
export class DatasetService {
  apiBaseUrl: string = window.location.origin + '/cs/';
  constructor(private request: HttpClient) {
    if (environment.envName == 'local') {
      this.apiBaseUrl = "http://localhost:5081/api";
    } else if (environment.envName == 'demo') {
      this.apiBaseUrl = "https://demo.litmusworld.com/cs/api/api";
    } else {
      this.apiBaseUrl += 'api/api'
    }

    if (environment.envName == 'staging') {
      this.apiBaseUrl = "https://staging.litmusworld.com/cs/api/api";
    }
  }

  getClientBaseUrl() {
    return this.apiBaseUrl;
  }

  upload(datasetFile:any, data:any, cb:any) {
    if (datasetFile) {
      var url = this.apiBaseUrl + '/datasetvalues/upload';

      let formData = new FormData();

      
      formData.append('file_name', datasetFile, datasetFile.name);
      formData.append('data', data);
      this.request.post(url,formData,{
        reportProgress: true,
        responseType: 'json'
      }).subscribe((response:any)=>{
        cb(response.data)
      })
    }
  };

  getDatasetValues(query: any, cb: any) {
    var url = this.apiBaseUrl + '/datasetvalues/list';
    this.request.get(url, {
      params: new HttpParams({
        fromObject: query
      })
    }).subscribe((response: any) => {
      if (response.code == 0 && response.data) {
        cb(response.data);
      } else {
        cb({ "data": {} })
      }
    }, function (err) {
      cb({ "data": {} })
    });
  };

  getByValues(query:any) {
    var url = this.apiBaseUrl + '/datasetvalues/by_values';
    return new Promise((resolve) => {
      this.request.post(url, query).subscribe((obj: any) => {
        resolve(obj.data);
      }, (err: any) => {
        resolve({ "error": true })
      })
    });
  }

  getDatasets(query:any, cb:any) {
    var url = this.apiBaseUrl + '/datasets/list';

    this.request.get(url, {
      params: new HttpParams({
        fromObject: query
      })
    }).subscribe((response: any) => {
      if (response.code == 0 && response.data.code == 0) {
        cb(response.data);
      } else {
        cb(response)
      }
    })
  }

  getDatasetValuesMap(datasetvalues: any, cb: any) {
    var promises: any = [];
    var valuesMap: any = {};
    // getting dataset values by values and datasetId
    if (!_.isEmpty(datasetvalues)) {
      for (var datasetId in datasetvalues) {
        if (datasetvalues[datasetId]) {
          var values = Object.keys(datasetvalues[datasetId]);
          var promise = this.getByValues({ dataset_id: datasetId, dataset_values: values })
          promises.push(promise)
        }
      }
    }
    // wating for all promises for dataset value 
    Promise.all(promises).then(function (data) {
      // preparing dataset values 
      data.forEach(function (response) {
        if (response && response.dataset_values && response.dataset_values.length) {
          response.dataset_values.forEach(function (dsv) {
            if (!valuesMap[dsv.dataset_id]) { valuesMap[dsv.dataset_id] = {} }
            valuesMap[dsv.dataset_id][dsv.name] = {
              label: dsv.label ? dsv.label : dsv.name,
              value: dsv.name
            };
          })
        }
      })
      cb(valuesMap)
    });
  };



}